/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ObjectResult } from '../../models/object-result';
import { UpdatePlayerOptionsCommand } from '../../models/update-player-options-command';

export interface ApiPlayerOptionsPost$JsonOdataStreamingFalse$Any$Params {
      body?: UpdatePlayerOptionsCommand
}

export function apiPlayerOptionsPost$JsonOdataStreamingFalse$Any(http: HttpClient, rootUrl: string, params?: ApiPlayerOptionsPost$JsonOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerOptionsPost$JsonOdataStreamingFalse$Any.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json;odata.streaming=false');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ObjectResult>;
    })
  );
}

apiPlayerOptionsPost$JsonOdataStreamingFalse$Any.PATH = '/api/player/options';
